import React, { useEffect, useState } from 'react';
import proptypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu } from 'antd';

import IconMoreMenu from '@/assets/images/icons/more-menu.svg';
import IconCard from '@/assets/images/icons/icons-card-filled.svg';
import IconPlus from '@/assets/images/icons/icons-plus.svg';
import IconMinus from '@/assets/images/icons/icons-minus.svg';
import IconPaperPlaneFilled from '@/assets/images/icons/icons-paperplane-filled.svg';
import IconPersonOutlined from '@/assets/images/icons/icons-person-outlined.svg';
import IconAdmin from '@/assets/images/icons/icons-chart.svg';

import './site-menu.scss';
import configs from '../../config';

const { SubMenu } = Menu;
const inventoryMenu = [
  { label: 'Categories', url: '/category' },
  { label: 'Products', url: '/product' },
];

const transactionMenu = [
  { label: 'Transaction List', url: '/transactions' },
  { label: 'Order List', url: '/orders' },
];

const menu = [
  {
    title: 'Inventory',
    key: 'inventory',
    icon: IconMoreMenu,
    children: inventoryMenu,
  },
  {
    title: 'Transactions',
    key: 'transaction',
    icon: IconCard,
    children: transactionMenu,
  },
  {
    key: 'customer',
    label: 'Customers',
    icon: IconPersonOutlined,
    url: '/customer',
  },
  {
    title: 'Admin',
    key: 'admin',
    icon: IconAdmin,
    children: [{ label: 'Tags', url: '/tag' }],
  },
  {
    title: 'Development tools',
    key: 'development_tools',
    icon: IconPaperPlaneFilled,
    children: [
      {
        key: 'temporary_requests',
        label: 'Request Log',
        url: '/temporary-requests',
      },
    ],
  },
].filter((_) => configs.enabledComponents === 'all' || _.key === configs.enabledComponents);

const getExpandIcon = ({ isOpen }) => (
  <img src={isOpen ? IconMinus : IconPlus} alt="expand icon" className="expand-icon icon" />
);

const SiteMenu = ({ location }) => {
  const [openKeysValue, setOpenKeys] = useState(['sub1']);
  const [selectedKeys, setSelectedKeys] = useState(['sub1']);

  /**
   * Get menus active
   * @returns
   */
  const getActiveKeys = () => {
    let path = location.pathname;
    const activeKeys = [];
    const openKeys = [];
    if (path === '/') {
      path = configs.ssoManagementOnly === 'true' ? '/customer' : '/product';
    }
    menu.forEach(({ key, children, ...props }) => {
      if (children)
        children.forEach(({ url }) => {
          if (path.indexOf(url) !== -1) {
            activeKeys.push(url);
            openKeys.push(key);
          }
        });
      if (path.indexOf(props.url) !== -1) {
        activeKeys.push(props.url);
        openKeys.push(key);
      }
    });
    setSelectedKeys(activeKeys);
    return setOpenKeys(openKeys);
  };

  useEffect(() => {
    getActiveKeys();
  }, [location]);

  const onOpenChange = (openKeys) => {
    const nOpenKeys = openKeys.pop();
    setOpenKeys([nOpenKeys]);
  };

  const renderSubMenu = () =>
    menu.map((props) => {
      if (props.children)
        return (
          <SubMenu
            key={props.key}
            title={props.title}
            icon={<img src={props.icon} alt="more menu icon" className="more-icon icon" />}
          >
            {props.children.map(({ label, url }) => (
              <Menu.Item key={url}>
                <Link to={url}>{label}</Link>
              </Menu.Item>
            ))}
          </SubMenu>
        );

      return (
        <div className="side-menu-item" key={props.url || ''}>
          <Menu.Item
            icon={<img src={props.icon} alt="more menu icon" className="more-icon icon" />}
          >
            <Link to={props.url || ''}>{props.label || ''}</Link>
          </Menu.Item>
        </div>
      );
    });

  return (
    <Layout.Sider className="site-menu" width="240">
      {configs.enabledComponents === 'all' && <div className="business-widget" />}
      <Menu
        selectedKeys={selectedKeys}
        defaultOpenKeys={['inventory']}
        openKeys={openKeysValue}
        mode="inline"
        className="side-menu"
        expandIcon={(props) => getExpandIcon(props)}
        onOpenChange={onOpenChange}
      >
        {renderSubMenu()}
      </Menu>
    </Layout.Sider>
  );
};

SiteMenu.propTypes = {
  location: proptypes.any,
};
export default withRouter(SiteMenu);
